import React, { useEffect, useState } from "react";
import store from "store2";

const FreezerTemperature = ({
  jobId,
  disabled = false,
}: {
  jobId: any;
  disabled?: boolean;
}) => {
  const [temperature, setTemperature] = useState<string>("");

  // Restore stored value on mount
  useEffect(() => {
    const jobData = store.get("job_id_data") || {};
    const stored = jobData[jobId]?.location?.freezerTemperature;
    if (stored !== undefined && stored !== null) {
      setTemperature(String(stored));
    }
  }, [jobId]);

  const handleChange = (value: string) => {
    setTemperature(value);
    const jobData = store.get("job_id_data") || {};
    jobData[jobId] = {
      ...jobData[jobId],
      location: {
        ...jobData[jobId]?.location,
        freezerTemperature: value,
      },
    };
    store.set("job_id_data", jobData);
  };

  return (
    <div className="accordion mt-4" id="freezerTemperatureAccordion">
      <div className="accordion-item">
        <h2 className="accordion-header" id="freezerTemperatureHeading">
          <button
            className="accordion-button collapsed py-5 fs-4 fw-bold bg-light"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#freezerTemperatureCollapse"
            aria-expanded="false"
            aria-controls="freezerTemperatureCollapse"
            title="Click here to enter freezer temperature"
          >
            Freezer Temperature
          </button>
        </h2>
        <div
          id="freezerTemperatureCollapse"
          className="accordion-collapse collapse"
          aria-labelledby="freezerTemperatureHeading"
          data-bs-parent="#freezerTemperatureAccordion"
        >
          <div className="accordion-body">
            <div className="row">
              <div className="col-12">
                <label className="fw-bold mb-2">Freezer Temperature (°F):</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter temperature"
                  value={temperature}
                  disabled={disabled}
                  onChange={(e) => handleChange(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreezerTemperature;
